// services/api/devolucionVentaApi.ts
import api from '../../utils/axios';
import { AxiosError } from 'axios';

export interface IDetalleDevolucionVenta {
  Id: number;
  IdDevolucionVenta: number;
  IdArticulo: number;
  Cantidad: number;
  FechaDevolucion: string;
  Observacion?: string;
  IdMotivoDevolucionVenta: number;
  articulo?: { Id: number; Nombre: string; EAN?: string };
}

export interface IDevolucionVenta {
  Id: number;
  CodigoFacturaVenta: string;
  Estado: boolean;
  detalles: IDetalleDevolucionVenta[];
}

export interface IArticuloParaDevolver {
  idArticulo: number;
  cantidad: number;
  idMotivo: number;
  observacion?: string;
}

export interface ICreateDevolucionVentaDto {
  codigoFactura: string;
  articulos: IArticuloParaDevolver[];
}

export interface IMotivoDevolucionVenta {
  Id: number;
  Nombre: string;
  Activo: boolean;
  Eliminado: boolean;
}

class DevolucionVentaApi {
  private readonly base = '/devoluciones-venta';
  private readonly baseMotivos = '/mantenimiento/motivo-devolucion-venta';

  private handleError(error: AxiosError): never {
    if (error.response) {
      const data = error.response.data as any;
      throw new Error(data?.message || 'Error en el servidor');
    }
    if (error.request) throw new Error('No se pudo conectar con el servidor');
    throw new Error('Error al procesar la solicitud');
  }

  async listar(): Promise<IDevolucionVenta[]> {
    try {
      const res = await api.post(`${this.base}/listar`);
      return res.data ?? [];
    } catch (e) {
      this.handleError(e as AxiosError);
    }
  }

  async buscarUna(id: number): Promise<IDevolucionVenta> {
    try {
      const res = await api.post(`${this.base}/buscar/${id}`);
      return res.data;
    } catch (e) {
      this.handleError(e as AxiosError);
    }
  }

  async procesar(dto: ICreateDevolucionVentaDto): Promise<any> {
    try {
      const res = await api.post(`${this.base}/procesar`, dto);
      return res.data;
    } catch (e) {
      this.handleError(e as AxiosError);
    }
  }

  async buscarVenta(params: { tipo: 'factura' | 'cliente'; termino: string }): Promise<any> {
    try {
      const res = await api.post(`${this.base}/buscar-devolucion`, params);
      return res.data;
    } catch (e) {
      this.handleError(e as AxiosError);
    }
  }

  async getMotivos(): Promise<IMotivoDevolucionVenta[]> {
    try {
      const res = await api.post(`${this.baseMotivos}/findAll`);
      return (res.data ?? []).filter((m: IMotivoDevolucionVenta) => m.Activo && !m.Eliminado);
    } catch {
      return [];
    }
  }
}

export const devolucionVentaApi = new DevolucionVentaApi();
export default devolucionVentaApi;
